module.exports = __webpack_public_path__ + "static/media/big-link.74caa494.png";